import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import { useAcceptInvitation } from '@services/global/invitations/accept';
import { UserType } from '@root/globalTypes';
import { useSchema } from '@hooks/forms/passwords/schema';

export const useAcceptInvitationForm = ({
  token,
  userType,
  successHandler,
}: {
  token: string;
  userType: UserType;
  successHandler: () => void;
}) => {
  const schema = useSchema();

  const defaultValues = {
    password: '',
    confirmPassword: '',
  };

  const form = useForm<z.infer<typeof schema>>({
    resolver: zodResolver(schema),
    defaultValues: defaultValues,
  });

  const { mutate, isPending, error } = useAcceptInvitation({
    callback: successHandler,
    token,
    userType,
  });

  const onSubmit = async (values: z.infer<typeof schema>) => {
    mutate({ password: values.password });
  };

  return {
    form,
    onSubmit,
    isPending,
    error,
  };
};
